import { ExtratoDeVendas } from '../../../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { ChartPeriodoOptions } from './chart-periodo-options'

export class ChartVendasOptions extends ChartPeriodoOptions {
    constructor(extrato: ExtratoDeVendas, descricaoPeriodo: string) {
        super(extrato, `Quanto vendi no ${descricaoPeriodo.toLowerCase()}`)
    }

    obterSeries(): { name: string; data: number[] }[] {
        if (!this.extrato) {
            return []
        }

        return this.extrato.agrupamentos.map(agrupamento => {
            return {
                name: agrupamento.operadora.nome,
                data: this.xAxis.categories.map(
                    categoria =>
                        categoria === agrupamento.operadora.nome
                            ? agrupamento.transacao.valorBruto
                            : null
                )
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/vendas-recebimentos/shared/chart-vendas-options.ts